import React from 'react';
import styles from './Grid.module.scss';

export type GridProps = {
  children: React.ReactNode;
  columns: number;
  columnGap?: number;
  rowGap?: number;
};

export default function Grid({
  children,
  columns,
  columnGap = 0,
  rowGap = 0,
}: GridProps) {
  const style = {
    gridTemplateColumns: new Array(columns).fill('1fr').join(' '),
    columnGap,
    rowGap,
  };

  return <div className={styles.grid} style={style}>{children}</div>;
}
